import Vue from "vue"
import vuetifyxPlugin from "../modules/vuetifyx/plugin";
import Vuetifyx from "../modules/vuetifyx/vuetifyx"

Vue.use(vuetifyxPlugin)

export default Vuetifyx
